import React, { FC } from 'react';

import { LucidTheme } from '@lucid/theme';

import Box from '../box/box';
import Container from '../container/container';
import Image from '../image/image';
import Text from '../text/text';
import { ComponentImage } from '../../types/generics';

export interface SimpleQuoteProps {
  /** The author of the quote. */
  attribution: string;
  /** The logo of the company for the quote. */
  image: ComponentImage;
  /** The content of the quote. */
  quote: string;
}

const SimpleQuote: FC<SimpleQuoteProps> = ({
  attribution,
  image,
  quote
}) => (
  <Container>
    <Box
      alignItems="center"
      display="flex"
      flexWrap="wrap"
      justifyContent="space-between"
      my={{ default: 6, tablet: 10 }}
    >
      <Box
        flex={{ default: '1 1 100%', tabletSmall: '0 1 25%' }}
        mb={{ default: 5, tabletLandscape: 0 }}
      >
        <Image
          alt={image.imageAlt || 'Quote Company Logo'}
          css={{ maxHeight: '75px' }}
          src={image.imageSrc}
        />
      </Box>
      <Box flex={{ default: '1 1 100%', tabletSmall: '0 1 70%' }}>
        <Text variant="paragraphXL300">
          &quot;
          {quote}
          &quot;
        </Text>
        <Box mt={3}>
          <Text css={(theme: LucidTheme) => ({ fontWeight: theme.fontWeights.strong })}>
            {attribution}
          </Text>
        </Box>
      </Box>
    </Box>
  </Container>
);

export { SimpleQuote };
export default SimpleQuote;
